import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import BoldText from "../../common/text/BoldText";
import LabeledText from "../../common/text/LabeledText";
import {withAuthorization} from "../../../services/Authorization";
import DeliveryModalTab from "./DeliveryModalTab";
import connect from "react-redux/es/connect/connect";
import Rental from "../../../services/Rental";

class RentalReportingModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deliveryReport: {...this.initReport()},
      identityDocuments: {...this.initReport()}
    }
  }

  initReport = () => {
    return {
      fileList: {
        attachments: [],
      },
      outdatedFiles: []
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.identityDocuments) {
      let {attachments = []} = nextProps.identityDocuments;
      attachments = attachments.map(a => ({uid: a.key}));
      this.setState({identityDocuments: {...this.initReport(), attachments}});
    }

    if (nextProps.reporting) {
      const {reporting: {deliveryReport, canBeDelivered}} = nextProps;
      const delivery = this.mapAttachmentsToPicture(deliveryReport);

      this.setState({
        canBeDelivered,
        deliveryReport: {
          ...this.initReport(),
          ...delivery
        }
      });
    }
  }

  mapAttachmentsToPicture = (report = {}) => {
    const reportCopy = Object.assign({}, report);
    if (reportCopy.attachments) {
      reportCopy.attachments = reportCopy.attachments.map(a => ({uid: a.key, url: a.url}));
    }
    return reportCopy;
  };

  onReportSave = () => {
    const {rentalDetails: {id}} = this.props;

    const {fileList: {attachments}, mileage, fuel, advisorComment, outdatedFiles} = this.state.deliveryReport;

    const form = new FormData();
    attachments && attachments.forEach((file) => {
      form.append('attachments', file)
    });

    mileage && form.append("mileage", mileage);
    fuel && form.append("fuel", fuel);
    advisorComment !== undefined && form.append("comment", advisorComment);
    form.append("outdatedFiles", outdatedFiles);

    this.onIdentityDocumentsSave();
    this.props.dispatchDeliverRental(id, form)
  };

  onIdentityDocumentsSave = () => {
    const {rentalDetails: {rentingJourney: {customer: {id}}}, journeyUuid} = this.props;
    const {identityDocuments: {fileList: {attachments} = {}, outdatedFiles} = {}} = this.state;

    if ((attachments && attachments.length > 0) || (outdatedFiles && outdatedFiles.length > 0)) {
      const form = new FormData();
      attachments.forEach((file) => {
        form.append('photos', file)
      });
      form.append("outdatedFiles", outdatedFiles);

      this.props.dispatchUpdateJourneyIdentityDocuments({uuid: journeyUuid, connectedUserId: id, body: form});
    }
  };

  onReportUpdate = (name, data) => {
    this.setState({[name]: data});
  };

  onIdentityDocumentsUpdate = (identityDocuments) => {
    this.setState({identityDocuments})
  };

  render() {
    const {intl: {formatMessage}, onModalClose, deliverRentalVehicle, rentalDetails, rentalVehicle, visible} = this.props;
    const {deliveryReport, identityDocuments} = this.state;

    const deliveryError = deliverRentalVehicle.error && deliverRentalVehicle.error.content;

    if (!rentalVehicle || !rentalDetails) {
      return null;
    }

    const isVinVehicle = Rental.isVinVehicle(rentalVehicle);
    const {rentingJourney: {customer = {}, vehicle = {}}} = rentalDetails;

    return (
      <Modal title={formatMessage({id: 'section.car-delivery.modal.title'})} visible={visible} onCancel={onModalClose} width='120rem' onOk={this.onReportSave}>

        <div className="row">
          <ul className="list col-md-6">
            <h3 className="box__subtitle">{formatMessage({id: 'summary.customer'})}</h3>
            <li><LabeledText label={'summary.customer'} text={`${customer.firstName} ${customer.lastName}`}/></li>
            <li><LabeledText label={'summary.phone'} text={customer.phone}/></li>
            <li><LabeledText label={'vehicle.vin'} text={<BoldText text={vehicle.vin} boldEndCharacters={7}/>}/></li>
          </ul>
          <ul className="list col-md-6">
            <h3 className="box__subtitle">{formatMessage({id: 'mobility.rental-car'})}</h3>
            <li><LabeledText label={'vehicle.make'} text={rentalVehicle.brand}/></li>
            <li><LabeledText label={'vehicle.model'} text={rentalVehicle.model}/></li>
            <li>
              {isVinVehicle &&
                <LabeledText label={'vehicle.vin'} text={<BoldText text={rentalVehicle.vin} boldEndCharacters={7}/>}/>
              }

              {!isVinVehicle &&
                <LabeledText label={'vehicle.serialNumber'} text={rentalVehicle.vin}/>
              }
            </li>
            <li><LabeledText label={'vehicle.category'} text={formatMessage({id: `mobility.${rentalVehicle.category}`})}/></li>
            {isVinVehicle &&
              <li><LabeledText label={'vehicle.gearbox'} text={rentalVehicle.gearbox ? formatMessage({id: `vehicle.gearbox.${rentalVehicle.gearbox}`}) : undefined}/></li>
            }
            <li><LabeledText label={'vehicle.plate'} text={rentalVehicle.licensePlate}/></li>
          </ul>
        </div>

        <br/>

        <DeliveryModalTab name="deliveryReport"
                          deliveryReport={deliveryReport}
                          identityDocuments={identityDocuments}
                          rentalVehicle={rentalVehicle}
                          onReportUpdate={this.onReportUpdate}
                          onIdentityDocumentsUpdate={this.onIdentityDocumentsUpdate}
                          errors={deliveryError}
        />
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  deliverRentalVehicle: state.deliverRentalVehicle
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateJourneyIdentityDocuments: (params) => dispatch({type: 'UPDATE.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
  dispatchDeliverRental: (rentalDetailsId, body) => dispatch({type: 'DELIVER_RENTAL_VEHICLE.REQUEST', rentalDetailsId, body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(RentalReportingModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
